export default function (instance) {
  instance.cascadeSort = () => {
    const resultTasks = [];

    // sort criteria priority - start/end date > duration > sortorder
    function sortByTaskCriteria(tasks) {
      tasks.sort((a, b) => {
        if ((new Date(a.start_date)).valueOf() !== (new Date(b.start_date)).valueOf()) {
          return new Date(a.start_date) - new Date(b.start_date);
        }

        const aDuration = instance.calculateDuration({ start_date: new Date(a.start_date), end_date: new Date(a.end_date), task: a });
        const bDuration = instance.calculateDuration({ start_date: new Date(b.start_date), end_date: new Date(b.end_date), task: b });

        if (aDuration !== bDuration) {
          return aDuration - bDuration;
        }

        return b.sortorder < a.sortorder;
      });

      return tasks;
    }

    const getCascadeTasks = taskId => {
      const activeTasks = [];

      instance.getChildren(taskId).forEach(item => {
        const currentTask = instance.getTask(item);

        if (currentTask.type !== instance.config.types.button) {
          activeTasks.push(currentTask);
        }
      });

      return activeTasks;
    };

    const processSortedTasks = sortedTasks => {
      sortedTasks.forEach((item, index) => {
        if (item.parent !== 1) {
          resultTasks.push({ id: item.id, sortorder: index });
        }
      });
    };

    const cascadeSort = taskId => {
      const activeTasks = getCascadeTasks(taskId);
      const sortedTasks = sortByTaskCriteria(activeTasks);

      processSortedTasks(sortedTasks);

      sortedTasks.forEach(item => {
        if (instance.getChildren(item.id)) {
          cascadeSort(item.id);
        }
      });
    };

    cascadeSort(instance.getTaskByIndex(0).id);

    const projectId = instance.config.gantt_id || instance.config.multiview_id;

    instance.callEvent('onCascadeSort', [resultTasks, projectId]);
  };
}
